import * as React from 'react'
import clsx from 'clsx'
import { useDroppable } from '@dnd-kit/core'
import { PlusIcon, UnstyledButton } from '@buffer-mono/popcorn'
import { getUnixTime } from 'date-fns'

import { usePostComposer } from '~publish/hooks/usePostComposer'
import type { Tag } from '~publish/gql/graphql'

import styles from './QueueSlot.module.css'

type QueueSlotProps = {
  date: string
  channelId: string
  tags: Tag[]
}

export const QueueSlot = React.forwardRef<HTMLButtonElement, QueueSlotProps>(
  ({ date, channelId, tags, ...props }, ref) => {
    const { triggerAttributes, createNewPinnedPostInComposer } =
      usePostComposer()

    const { setNodeRef, isOver, active } = useDroppable({
      id: date,
      data: { type: 'slot', date },
    })

    return (
      <UnstyledButton
        {...props}
        {...triggerAttributes}
        className={clsx(
          styles.slot,
          isOver && styles.over,
          active?.id && styles.dragInProgress,
        )}
        data-datetime={date}
        data-testid="queue-slot"
        onClick={(): Promise<void> =>
          createNewPinnedPostInComposer({
            cta: 'publish-singleChannel-queue-slot-1',
            channels: [channelId],
            prefillPostData: {
              pinned: true,
              dueAt: getUnixTime(date),
              tags,
            },
          })
        }
        ref={(node): void => {
          setNodeRef(node)
          if (typeof ref === 'function') ref(node)
          else if (ref) ref.current = node
        }}
      >
        <PlusIcon /> New
      </UnstyledButton>
    )
  },
)

QueueSlot.displayName = 'QueueSlot'
